import Vue from 'vue'
import moment from 'moment'

function hasDatePassed(eventDate) {
  const now = moment()
  const diff = now.diff(eventDate, 'hours')

  return diff >= 24
}

Vue.filter('eventDate', function (event) {
  console.log('event date raw', event.date)

  const eventDate = moment.utc(event.date, 'x')

  console.log('eventDate', eventDate.toISOString())

  const now = moment.utc()

  console.log('now', now.toISOString())

  const today = now.clone().startOf('day')
  const tomorrow = now.clone().add(1, 'days').startOf('day')

  console.log('today', today.toISOString())
  console.log('tomorrow', tomorrow.toISOString())

  // Past (include year)
  if (hasDatePassed(eventDate)) {
    return `${eventDate.format('M/D/YYYY')}`
  }

  if (eventDate.isSame(today, 'd')) {
    return `Tonight, ${eventDate.format('M/D')}`
  }

  if (eventDate.isSame(tomorrow, 'd')) {
    return `Tomorrow, ${eventDate.format('M/D')}`
  }

  return `${eventDate.format('dddd MMMM Do')}`
})



// WEBPACK FOOTER //
// ./src/filters/eventDate.js